import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3733ea36&scoped=true&"
import script from "./index.vue?vue&type=script&lang=ts&setup=true&"
export * from "./index.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./index.vue?vue&type=style&index=0&id=3733ea36&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3733ea36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3733ea36')) {
      api.createRecord('3733ea36', component.options)
    } else {
      api.reload('3733ea36', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3733ea36&scoped=true&", function () {
      api.rerender('3733ea36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/services/index.vue"
export default component.exports